import { render, staticRenderFns } from "./TenTable.vue?vue&type=template&id=e1812f7c&"
import script from "./TenTable.vue?vue&type=script&lang=js&"
export * from "./TenTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports